<template>
  <div class="goods_index" v-if="result.data">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item >首页</el-breadcrumb-item>
      <el-breadcrumb-item >我的采购单</el-breadcrumb-item>
    </el-breadcrumb>
      <el-card>
      <el-row>
          <el-col :span="3">
              <el-button type="primary"  @click="ordersService">订单发货</el-button>
          </el-col>

      </el-row>
      </el-card>
      <div class="title"><span class="el-icon-truck"></span>快递公司</div>
      <el-card>
          <el-row>
              <el-col
              >
                  快递公司:{{ result.data.express }} 运单号:{{ result.data.orderno }} 日期: {{ formatGMT(result.data.logistics_add_date) }}
                </el-col
              >
          </el-row>
      </el-card>
    <div class="title"><span class="el-icon-truck"></span>收货地址</div>
    <el-card>
      <el-row>
        <el-col
          >{{ result.data.user_addr.province }}{{ result.data.user_addr.city }}
          {{ result.data.user_addr.county }}
          {{ result.data.user_addr.detail }}
          {{ result.data.user_addr.name }}
          {{ result.data.user_addr.phone }}</el-col
        >
      </el-row>
    </el-card>

    <div class="title"><span class="el-icon-notebook-2"></span>订单详细</div>
      <el-card>
          <el-row  v-if="result">
              <el-col
              ><span class="el-icon-right"></span>{{ result.data.oid }} 下单日期:{{
                      formatGMT(result.data.created_time)
                  }}
              </el-col>
          </el-row>
          <div
                  v-for="(v, index) in result.data.order_info"
                  :key="index"
                  class="order_content"

          >

              <el-row class="title">
                  <el-col> 款号：{{v.title}}
                      采购价:{{ v.totalprice }}元
                  </el-col>
              </el-row>


              <el-row  v-for="(vv, index1) in v.detail"
                       :key="index1">
                  <el-col>

                      <img :src="result.data.product_pic_items[vv.color_label+'_'+vv.pro_id]['pic'][0]['url']" v-if="result.data.product_pic_items[vv.color_label+'_'+vv.pro_id]!=null" style="width: 100px; height: 100px" >
                      <span v-else>暂无图片</span>
                  </el-col>
                  <el-col>
                      属性: {{ vv.color_label }}{{ vv.size_label }} 数量:{{ vv.qty }} 价格{{ vv.price }}
                  </el-col>
              </el-row>
          </div>

      </el-card>
      <el-card>

      </el-card>
      <el-dialog title="选择物流" :visible.sync="dialogFormVisible">
          <div class="title1">订单号:{{ form.oid }}</div>
          <el-form :model="form" :rules="rules" ref="myform">
              <el-form-item label="请选择物流" prop="express" >
                  <el-select v-model="form.express" placeholder="请选择发货物流" >
                      <el-option :label="v.name" :value="v.name" v-for="(v, i) in express.data" :key="i"></el-option>

                  </el-select>
              </el-form-item>
              <el-form-item label="物流单号" prop="orderno">
                  <el-input  v-model="form.orderno" autocomplete="off"></el-input>
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click.native="addLogistics('myform')">确 定</el-button>
          </div>
      </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
        form:{
            oid:"",
            orderno:'',
            express:'',
        },
        rules: {
            orderno: [
                { required: true, message: '请输入物流单号', trigger: 'blur' },

            ],
            express: [
                { required: true, message: '请选择物流', trigger: 'change' }
            ]},
      multipleSelection: [],
      dialogFormVisible: false,
      dialogStoreVisible: false,

      dialog_restore_visible: false,
      id: 0,
    };
  },
  methods: {
    ...mapActions({
      getMyorderDetailAction: "getMyorderDetailAction",
        getExpressIndexAction:"getExpressIndexAction",
        editOrderExpressAction:"editOrderExpressAction"
    }),
      ordersService() {

          this.dialogFormVisible = true;

          this.form.oid = this.result.data.oid;

      },
      addLogistics(formName){

          this.$refs[formName].validate((valid) => {
              if (valid) {

                  this.editOrderExpressAction({
                      oid:this.form.oid,
                      orderno:this.form.orderno,
                      express:this.form.express,
                  })
                  this.dialogFormVisible=false
              } else {
                  console.log('error submit!!');
                  return false;
              }
          });



      },
    formatGMT(gmt, long) {
      long = false === long ? false : true;
      let date = new Date(gmt);

      let m = date.getMonth() + 1,
        mm = "-" + (m < 10 ? "0" + m : m);
      let d = date.getDate(),
        dd = "-" + (d < 10 ? "0" + d : d);
      let h = date.getHours(),
        hh = " " + (h < 10 ? "0" + h : h);
      let i = date.getMinutes(),
        ii = ":" + (i < 10 ? "0" + i : i);
      let s = date.getSeconds(),
        ss = ":" + (s < 10 ? "0" + s : s);

      return date.getFullYear() + mm + dd + (long ? hh + ii + ss : "");
    },
  },
  created() {
    this.id = this.$route.params.id;

    this.getMyorderDetailAction({ id: this.id });
      this.getExpressIndexAction({})
  },
  //tableData
  computed: mapState({
    result: (state) => state.order.result,
      express:  (state) => state.express.result,
  }),
    watch:{
        result(newdata){
            this.form.express=newdata.data.express
            this.form.orderno=newdata.data.orderno
        },
        express(newdata){


            if(newdata.code==301){
                this.$message({
                    message: '发货物流编辑成功',
                    type: 'success'
                });
                this.getExpressIndexAction({})
                this.getMyorderDetailAction({ id: this.id });
                // this.getMyorderDetailAction({ id: this.id });
                // this.getExpressIndexAction({})
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dialog-footer {
  text-align: center;
  background-color: gainsboro;
  padding: 0.3rem;
}
</style>
